import { ActivityManager } from '../services';

const state = {
  liveMessage: '',
  resources: {},
  loading: false,
  isLoadingCompleted: false,
  percentage: 0,
  error: null,
  currentComponent: null,
};

const getters = {
  getCompanyName() {
    return process.env.VUE_APP_COMPANY_NAME;
  },
  getLiveMessage: (state) => {
    return state.liveMessage;
  },
  getData: (state) => {
    return state.resources.data || [];
  },
  getImages: (state) => {
    return state.resources.media?.images || [];
  },
  getVideos: (state) => {
    return state.resources.media?.videos || [];
  },
  getAudios: (state) => {
    return state.resources.media?.audios || [];
  },
  getPercentage: (state) => {
    return state.percentage;
  },
  getLoading: (state) => {
    return state.loading;
  },
  isActivityLoadingCompleted: (state) => {
    return state.isLoadingCompleted;
  },
  isPreloadCompleted(state) {
    return state.percentage === 100;
  },
  getError: (state) => {
    return state.error;
  },
  getCurrentComponent: (state) => {
    return state.currentComponent;
  },
  getImageById: () => (id) => {
    return ActivityManager.getMediaById('image', id);
  },
  hasAudioById: (state) => (id) => {
    return !!state.resources.media.audios.find((sound) => sound.id === id);
  },
  getAudioById: (state) => (id) => {
    const audio = state.resources.media.audios.find((sound) => sound.id === id);
    return audio ? audio.src : null;
  },
  getVideoById: (state) => (id) => {
    const video = state.resources.media.videos.find(
      (videoMedia) => videoMedia.id === id,
    );
    return video.src;
  },
};

const actions = {
  setActivityResources({ commit }, resources) {
    if (resources) {
      commit('fetchActivityStart');

      return ActivityManager.load(resources)
        .then(() => {
          commit('fetchActivityResponse', {
            media: ActivityManager.media,
            data: ActivityManager.data,
          });
        })
        .catch((e) => {
          commit('fetchActivityError', e);
        });
    }
  },
  removeActivityResources({ commit }) {
    commit('fetchActivityDestroy');
  },
  onSwapComponent({ commit }, currentComponent) {
    commit('setCurrentComponent', currentComponent);
  },
  setLiveMessage({ commit }, message) {
    commit('setLiveMessage', message);
  },
  setVideos: ({ commit }, objVideo) => {
    commit('setVideos', objVideo);
  },
};

const mutations = {
  fetchActivityStart(state) {
    state.resources = {};
    startLoading(state);
  },
  fetchActivityResponse(state, resources) {
    state.resources = resources;
  },
  fetchActivityError(state, error) {
    state.error = error;
    state.resources = {};
  },
  fetchActivityDestroy(state) {
    state.resources = {};
    state.loading = false;
    state.isLoadingCompleted = false;
    state.percentage = 0;
    state.error = null;
  },
  setCurrentComponent(state, currentComponent) {
    state.currentComponent = currentComponent;
  },
  setLiveMessage(state, liveMessage) {
    state.liveMessage = liveMessage;
  },
  setVideos(state, objVideo) {
    state.resources.media.videos.push(objVideo);
  },
};

const startLoading = (state) => {
  state.loading = true;
  state.isLoadingCompleted = false;
  state.percentage = 0;

  const incrementOrFinishLoading = () => {
    if (state.percentage < 100) {
      state.percentage = ActivityManager.percentLoaded();
    } else {
      finishLoading(state);
      clearInterval(fauxProgress);
    }
  };
  const fauxProgress = setInterval(incrementOrFinishLoading, 10);
};

const finishLoading = (state) => {
  state.percentage = 100;
  state.loading = false;
  state.isLoadingCompleted = true;
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
